export default __webpack_public_path__ + "static/media/pattern-dots.0a312038.svg";